import request from '@/utils/request'

/** 订单列表 */
export function getOrderList(claimStatus, keyword, realName,verifyCode,page = 1, size = 10) {
  return request({
    url: '/manage/order/list',
    method: 'get',
    params: { claimStatus, keyword, realName,verifyCode, page, size }
  })
}


export function getOrderAllList(claimStatus, keyword, realName,verifyCode) {
  return request({
    url: '/manage/order/allList',
    method: 'get',
    params: { claimStatus, keyword, realName,verifyCode }
  })
}


/** 下载每日预生成的核销记录（Blob 方式，可带 token） */
export function downloadDailyExport(date) {
  return request({
    url: '/manage/order/downloadDailyExport',   // ← 以你 Controller 实际路径为准
    method: 'get',
    params: date ? { date } : {},               // 可选：'20261009' 或 '2026-10-09'，不传=今天
    responseType: 'blob',
    timeout: 5 * 60 * 1000                      // 文件可能较大，放宽超时
  })
}

/** 订单详情 */
export function getOrderDetail(id) {
  return request({
    url: `/manage/order/detail/${id}`,
    method: 'get'
  })
}

/** 手动取消订单 */
export function cancelOrder(id, reason) {
  return request({
    url: `/manage/order/cancel/${id}`,
    method: 'post',
    data: { reason }
  })
}

/** 核销记录列表 */
export function getVerifyLog(merchantId, verifyCode, page = 1, size = 10) {
  return request({
    url: '/manage/order/verify-log',
    method: 'get',
    params: { merchantId, verifyCode, page, size }
  })
}